import { ComponentRoute } from '@/classes'

const PartsCatalogueRoutes = {
  PartsCatalogueListView: new ComponentRoute('/partscatalogues/', 'PartsCatalogueListView'),
  PartsCatalogueItemListView: new ComponentRoute('/partscatalogues/:partsCatalogNo/:make/:modelCode', 'PartsCatalogueItemListView')
}

export default PartsCatalogueRoutes
